import { Injectable, Type } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { UnsaveChangesService } from './unsave-changes.service';

@Injectable({ providedIn: 'root' })
export class UnsafeChangesGuard implements CanDeactivate<Type<any>> {
	constructor(readonly unsaveChanges: UnsaveChangesService) {}

	canDeactivate(
		component: Type<any>,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		// tslint:disable-next-line:no-console
		// console.log({ component });
		return this.unsaveChanges.hasUnsavedChanges().pipe(
			mergeMap(hasUnsavedChanges => {
				// console.log({currentRoute, currentState, nextState});
				// ignore double check
				if (hasUnsavedChanges && nextState?.url !== '/') {
					return this.unsaveChanges.confirmUnsave();
				}
				return of(true);
			})
		);
	}
}
